import { type TableParamsType } from '../../types/common';
import { type UseQueryResult, useQuery } from 'react-query';
import {
  EmployeeTypeService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_EmployeeTypeDto,
} from '@wealthlane/api-services/wealthlane-customer-service';

const useGetEmployeeTypesListWithPagination = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_EmployeeTypeDto | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount, isTaxEnable, _force } = tableInfo;
  const EmployeeTypesList = useQuery(
    [
      'getEmployeeTypesListWithPagination',
      filter,
      sorting,
      skipCount,
      maxResultCount,
      isTaxEnable,
      _force,
    ],
    async () => {
      return await handleRequest(
        EmployeeTypeService.getApiCustomerApiAppEmployeeTypeEmployeeTypesList(
          isTaxEnable,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return EmployeeTypesList;
};

export default useGetEmployeeTypesListWithPagination;
